/**
 * Lifetime (in seconds) of the Storage signed URLs the API issues for inline
 * media: avatars and receipts, rendered repeatedly while a page stays open.
 * The browser caches an API-issued URL for less than this.
 */
export const MEDIA_DOWNLOAD_TTL_SECONDS = 60 * 60;
